import { Component, Input, HostListener, ElementRef } from '@angular/core';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  standalone: false,
})
export class SidenavComponent {
  @Input() isMenuOpen: boolean = true;
  @Input() isHandset: boolean = false;

  constructor(private elementRef: ElementRef) {}

  toggle(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);

    if (!clickedInside && this.isMenuOpen && this.isHandset) {
      this.toggle();
    }
  }
}
